import { gql } from '@apollo/client';

const LOOKUP_ARTICLE_PRICE_LIST_ROWS = gql`query lookupArticlePriceListRows($companyId: Int!, $articleNo: String){
  companyAdminContext {
		salesDocuments {
			lookupArticlePriceListRows(companyId: $companyId, articleNo: $articleNo) {
			  amount
				articleNo
				description
				price
			}
		}
	}
}`;

export default LOOKUP_ARTICLE_PRICE_LIST_ROWS;
